import * as React from 'react';

import { FieldProps } from 'formik';

import Autocomplete, { AutocompleteProps } from '@common/react/components/Forms/Autocomplete/Autocomplete';
import { ZipCode } from '@common/typescript/objects/ZipCode';

export interface ZipAutocompleteProps {
	onSelect: (value, option) => void;
	fieldProps: FieldProps;
	onChange?: (value: string) => void;
	other?: Omit<AutocompleteProps<ZipCode>, 'type' | 'renderTitle' | 'onSelect' | 'onChange' | 'value'>;
}

export const ZipAutocomplete: React.FC<ZipAutocompleteProps> = ({
	onSelect, fieldProps: { field, form }, onChange, other,
}) => {
	const defaultOnChange = (value = '') => form.setFieldValue(field.name, value);

	return <Autocomplete<ZipCode>
		{...other}
		type="zipCodeList"
		renderTitle="zip"
		onSelect={onSelect}
		onChange={onChange || defaultOnChange}
		value={field.value}
	/>;
};
